const getRoomAsOption = ({ id, roomNumber, property }) => ({
  key: id,
  text: `${roomNumber} - ${property?.name}`,
  value: id
});

export default { getRoomAsOption };
